import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import ExecutiveCommittee from '../../components/ExecutiveCommittee';

const ToabPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={'Committee of TOAB'} />
      <ExecutiveCommittee association='TOAB' />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ToabPage;
